<template>
  <Prepaiement v-if="is_payment" />
  <div v-else id="root" class="resa_page">
    <!-- <div class="tables_buttons_booking">
      <div class="resa_header_content">
        <div class="resa_header_left">
          <h2 class="new_page_title dark text-start">Choisissez votre table</h2>
        
          <div class="spaces_section11">
            <div
              :class="`space_section11 ${
                selectedSpace == index ? 'active' : ''
              }`"
              @click="selectedSpace = index"
              v-for="(espace, index) in active_espaces"
              :key="`space_section${index}`"
            >
              {{ espace.name }}
            </div>
          </div>
        </div>
        <div class="resa_header_right">
          <b-dropdown
            variant="link"
            toggle-class="text-decoration-none"
            no-caret
            style="background-color: transparent"
          >
            <template #button-content>
              <div class="tables_button1">
                <span>{{ rvc.label }}</span>
                <img
                  src="htttp://localhost:3333/new_images/arrow.svg"
                  class="down_light dark"
                  alt=""
                  srcset=""
                />
              </div>
            </template>
            <b-dropdown-item
              v-for="(center, index) in centers"
              :key="`center_${index}`"
              @click="rvc = center"
              >{{ center.label }}</b-dropdown-item
            >
          </b-dropdown>
        </div>

      </div>
    </div> -->
    

    <div
      class="new_resa_modal"
      v-if="detail_table != -1 && !showSuccessMessage"
    >
      <div class="new_resa_mask" @click="detail_table = -1"></div>

      <div class="resa_infos_popup">
        <div class="resa_tabs">
          <!-- <div :class="`resa_tab ${active_resa==1?'active':''} `" @click="active_resa=1">New</div>
                  <div :class="`resa_tab ${active_resa==2?'active':''} `" @click="active_resa=2">Reservations list</div> -->
        </div>
        <div class="resa_infos_popup_header">
          <div class="left_side">
            <span class="time orange_text">{{
              getDateFormat(new Date(), "HH:mm")
            }}</span>
            <span class="date orange_text">{{
              getDateFormat(new Date(), "MMM YY.MM.DD")
            }}</span>
          </div>
          <div class="right_side orange_text">{{ detail_table }}</div>
        </div>
        <div class="resa_infos_popup_form">
          <div class="resa_infos_popup_row">
            <div class="resa_infos_popup_col">
              <label>Date</label>
              <!-- <input type="text"  placeholder="-- -- --" class="resa_infos_popup_input" id="date"> -->
              <!-- <vuejs-datepicker :disabled-dates="disabledDates"  v-model="date" ></vuejs-datepicker> -->
              <!-- <the-mask
                        placeholder="--/--/----"
                        @input="changeDate"
                        ref="input_date"
                        :mask="'####-##-##'"
                        class="resa_infos_popup_input input_date"
                        type="date"
                        /> -->
              <VueMaterialDateTimePicker
                v-model="reservation.date"
                :valueFormatted="`${getDateFormat(
                  reservation.date,
                  'YYYY/MM/DD'
                )}`"
                :is-date-only="true"
              />
            </div>
            <div class="resa_infos_popup_col">
              <label>Heure</label>
              <VueMaterialDateTimePicker
                v-model="reservation.time"
                :minute-step="10"
                :valueFormatted="`${getDateFormat(reservation.time, 'HH:mm')}`"
                :is-time-only="true"
              />
              <!-- <the-mask step="300" placeholder="--:--" v-model="reservation.time"  :mask="['##:##']" class="resa_infos_popup_input" type="time"  /> -->
              <!-- <input type="text"   placeholder="-- --" class="resa_infos_popup_input"  id="time"> -->
            </div>
          </div>

          <div class="resa_infos_popup_row">
            <div class="resa_infos_popup_col">
              <label>Nom</label>
              <input
                type="text"
                v-model="reservation.nom"
                placeholder=""
                class="resa_infos_popup_input"
                id="nom"
              />
            </div>
            <div class="resa_infos_popup_col">
              <label>Prenom</label>
              <input
                type="text"
                v-model="reservation.prenom"
                placeholder=""
                class="resa_infos_popup_input"
                id="prenom"
              />
            </div>
          </div>
          <div class="resa_infos_popup_row">
            <div class="resa_infos_popup_col">
              <label>Telephone</label>
              <input
                type="text"
                v-model="reservation.phone"
                placeholder=""
                class="resa_infos_popup_input"
                id="phone"
              />
            </div>
            <div class="resa_infos_popup_col">
              <label>Email</label>
              <input
                type="text"
                v-model="reservation.email"
                placeholder=""
                class="resa_infos_popup_input"
                id="email"
              />
            </div>
          </div>
          <div class="resa_infos_popup_row">
            <div class="resa_infos_popup_col">
              <label>Commentaire<span class="orange_text">.</span>s</label>
              <textarea
                v-model="reservation.comment"
                placeholder="Ajouter un commentaire"
                class="resa_infos_popup_input"
                id="comment"
                rows="3"
              >
              </textarea>
            </div>
          </div>
          <div class="resa_infos_popup_row">
            <div class="resa_infos_popup_col">
              <label for="phone"
                >Nombre de personne<span class="orange_text">.</span>s</label
              >
              <div class="resa_popup_adults">
                <img
                  @click="reservation.adultes = 1"
                  class="resa_user_icon"
                  :src="`htttp://localhost:3333/new_images/${
                    reservation.adultes >= 1
                      ? 'user_icon_active.png'
                      : 'user_icon.png'
                  }`"
                  alt=""
                  srcset=""
                />
                <img
                  @click="reservation.adultes = 2"
                  class="resa_user_icon"
                  :src="`htttp://localhost:3333/new_images/${
                    reservation.adultes >= 2
                      ? 'user_icon_active.png'
                      : 'user_icon.png'
                  }`"
                  alt=""
                  srcset=""
                />
                <img
                  @click="reservation.adultes = 3"
                  class="resa_user_icon"
                  :src="`htttp://localhost:3333/new_images/${
                    reservation.adultes >= 3
                      ? 'user_icon_active.png'
                      : 'user_icon.png'
                  }`"
                  alt=""
                  srcset=""
                />
                <img
                  @click="reservation.adultes = 4"
                  class="resa_user_icon"
                  :src="`htttp://localhost:3333/new_images/${
                    reservation.adultes >= 4
                      ? 'user_icon_active.png'
                      : 'user_icon.png'
                  }`"
                  alt=""
                  srcset=""
                />
                <img
                  @click="reservation.adultes = 5"
                  class="resa_user_icon"
                  :src="`htttp://localhost:3333/new_images/${
                    reservation.adultes >= 5
                      ? 'user_icon_active.png'
                      : 'user_icon.png'
                  }`"
                  alt=""
                  srcset=""
                />
                <img
                  @click="reservation.adultes = 6"
                  class="resa_user_icon"
                  :src="`htttp://localhost:3333/new_images/${
                    reservation.adultes >= 6
                      ? 'user_icon_active.png'
                      : 'user_icon.png'
                  }`"
                  alt=""
                  srcset=""
                />
                <img
                  @click="reservation.adultes = 7"
                  class="resa_user_icon"
                  :src="`htttp://localhost:3333/new_images/${
                    reservation.adultes >= 7
                      ? 'user_icon_active.png'
                      : 'user_icon.png'
                  }`"
                  alt=""
                  srcset=""
                />
                <img
                  @click="reservation.adultes = 8"
                  class="resa_user_icon"
                  :src="`htttp://localhost:3333/new_images/${
                    reservation.adultes >= 8
                      ? 'user_icon_active.png'
                      : 'user_icon.png'
                  }`"
                  alt=""
                  srcset=""
                />
              </div>
            </div>
          </div>
        </div>
        <div class="buttons_section_resa">
          <div class="button_cancel_resa" @click="detail_table = -1">
            Annuler
          </div>
          <div class="button_save_resa" @click="addItem">Enregistrer</div>
        </div>
      </div>
    </div>
    <div class="page_container_tables_sub">
      <div class="page_container_tables">
        <div class="planing_container">
          <div
            class="planing_section"
            @click.self="clickoutSide()"
            v-if="!startGetTables && 1 != 1"
          >
            <template v-for="(item, index) in filtredData">
              <div
                :style="{
                  top: `${item.top}px`,
                  left: `${item.left}px`,
                  width: `${item.width}px`,
                  height: `${item.height}px`,
                }"
                :key="`key2_${index}`"
                class="vdr active box-shaddow"
              >
                <template v-if="!item.element">
                  <!-- @click.exact="detail_table=item.Name.StringText._text*1" -->
                  <div
                    @click="
                      (e) => {
                        setDetail(item.Name.StringText._text * 1, e, item);
                        selectedTableId = item._id;
                      }
                    "
                    :class="`content_box ${item.type}  ${
                      selectedTableId == item._id ? 'active' : ''
                    }`"
                    :data-table="item.Name.StringText._text * 1"
                  >
                    <template v-if="!item.MaximumCovers">
                      <!-- <div class="table_chair top_chair" :data-table="item.Name.StringText._text*1"></div>
                    <div class="table_chair top_chair" :data-table="item.Name.StringText._text*1"></div>
                    <div class="table_chair top_chair" :data-table="item.Name.StringText._text*1"></div>
                    <div class="table_chair top_chair" :data-table="item.Name.StringText._text*1"></div> -->
                    </template>

                    <template v-else>
                      <template v-if="item.MaximumCovers > 1">
                        <div class="table_top_container">
                          <div
                            class="table_chair"
                            v-for="(elm, elm_index) in getChairs(
                              item.MaximumCovers
                            )"
                            :key="`chaire${item._id}_${elm_index}`"
                            :data-table="item.Name.StringText._text * 1"
                          ></div>
                        </div>
                        <div class="table_bottom_container">
                          <div
                            class="table_chair"
                            v-for="(elm, elm_index) in getChairs(
                              item.MaximumCovers
                            )"
                            :key="`chaire${item._id}_${elm_index}2`"
                            :data-table="item.Name.StringText._text * 1"
                          ></div>
                        </div>

                        <div class="table_left_container">
                          <div
                            class="table_chair"
                            :data-table="item.Name.StringText._text * 1"
                          ></div>
                        </div>
                        <div class="table_right_container">
                          <div
                            class="table_chair"
                            :data-table="item.Name.StringText._text * 1"
                          ></div>
                        </div>
                      </template>
                      <template v-else>
                        <div class="table_left_container">
                          <div
                            class="table_chair left"
                            :data-table="item.Name.StringText._text * 1"
                          ></div>
                        </div>
                      </template>
                    </template>
                    <div
                      class="table_blur"
                      :data-table="item.Name.StringText._text * 1"
                    >
                      <span class="table_blur_number"
                        >{{ item.Name.StringText._text }} <br
                      /></span>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="element_item">
                    <img :src="item.url" class="" alt="" srcset="" />
                  </div>
                </template>
              </div>
            </template>
          </div>

          <div class="planing_section" v-if="!startGetTables">
            <!-- <VFlowChart
              ref="flowChart"
              :visibleOption="false"
              :enableOptions="true"
              :showOptions="true"
              :connecting="true"
              :nodes="nodes_v1"
              :transformation1="transformation"
              :conns="[]"
              @node-click="clickNode"
              :reservations_data="[]"
              :enableNodeContextMenu="true"
              :connLineType="'step'"
            >
              <div
                slot="nodeContextmenu"
                slot-scope="props"
                class="context__container d-inline-flex"
              >
                <div class="context__button">
                  <a
                    href="javascript:;"
                    class="context__link my-auto d-inline-flex"
                  >
                    <i class="bi bi-circle-fill bg-white"></i
                    ><i class="bi bi-caret-down"></i>
                  </a>
                </div>
                <div class="context__button">
                  <a href="javascript:;" class="context__link">
                    <i class="bi bi-border-outer"></i>
                  </a>
                </div>
                <div class="context__button">
                  <a href="javascript:;" class="context__link">
                    <i class="bi bi-type-underline"></i>
                  </a>
                </div>
                <div class="context__button" style="width: 150px">
                  <select
                    class="form-select"
                    aria-label="Default select example"
                  >
                    <option selected>Small</option>
                  </select>
                </div>
                <div
                  class="context__button-2"
                  @click="$refs.flowChart.removeNode(props.node.id)"
                >
                  <a href="javascript:;" class="context__link">
                    <i class="bi bi-trash3"></i>
                  </a>
                </div>
              </div>
              <div slot="connContextmenu" class="context__container"></div>

              <div class="toolbar" slot="footer">
                <div class="context__button">
                  <a href="javascript:;" class="context__link">
                    <i class="bi bi-cursor"></i>
                  </a>
                </div>
                <div class="context__button">
                  <a href="javascript:;" class="context__link">
                    <i class="bi bi-hand-index-thumb"></i>
                  </a>
                </div>
                <div class="context__button" @click="$refs.flowChart.addNode()">
                  <a href="javascript:;" class="context__link">
                    <i class="bi bi-plus-lg"></i>
                  </a>
                </div>
                <div class="context__button">
                  <a href="javascript:;" class="context__link">
                    <i class="bi bi-arrow-counterclockwise"></i>
                  </a>
                </div>
                <div class="context__button">
                  <a href="javascript:;" class="context__link">
                    <i class="bi bi-arrow-clockwise"></i>
                  </a>
                </div>
              </div>
            </VFlowChart> -->

            <div class="table-layout-section">
              <!-- Room Tabs -->
              <div class="room-tabs">
                <div
                  @click="selectedSpace = index"
                  :class="['room-tab', { active: selectedSpace === index }]"
                  v-for="(espace, index) in espaces"
                  :key="`top_espace_${index}`"
                >
                  {{ espace.name }}
                </div>
               
              </div>

              <!-- Table Layout Area -->
               <div class="tables-new-container">
              <div class="table-layout-area" :style="{ 
                minWidth: containerDimensions.width, 
                minHeight: containerDimensions.height 
              }">
                <!-- Tables -->
                <div
                  v-for="table in filtredData"
                  :key="table.id"
                  class="table-element"
                  :class="[
                    table.shape,
                    // tables_status[table._id].status,
                    {
                      dragging: table.id === draggingTableId
                    },
                  ]"
                  :style="{
                    left: table.left + 'px',
                    top: table.top + 'px',
                    width: table.width + 'px',
                    height: table.height + 'px',
                    transform: `rotate(${table.rotation || 0}deg)`,
                    zIndex: table.id === draggingTableId ? 1000 : 1,
                    backgroundColor: tables_status_colors[
                      table.DiningTableID._text
                    ]
                      ? tables_status_colors[table.DiningTableID._text] + '60'
                      : '#FFFFFF',
                    backgroundColor: '#ffffff',
                  }"
                  @click="clickTable(table)"
                >
                  <div
                    class="mask-table"
                    :style="{
                      backgroundColor: tables_status_colors[
                        table.DiningTableID._text
                      ]
                        ? tables_status_colors[table.DiningTableID._text] + '20'
                        : '#FFFFFF',
                    }"
                  ></div>
                  <div class="table-content">
                    <span class="table-number">{{ table.Name.StringText._text }} </span>
                    <span
                      class="table-capacity"
                      v-if="table.capacity "
                      >{{ table.capacity }}</span
                    >
                 
                    <!-- Reservation Information -->
                   
                  </div>
                  <div class="table-status-indicator" v-if="table.statusColor">
                    <div
                      class="status-dot"
                      :style="{ backgroundColor: table.statusColor }"
                    ></div>
                  </div>

                  <!-- Table Controls (shown in edit mode) -->
                
                </div>

                <!-- Bar Area -->
                <!-- <div class="bar-area">
            <span class="area-label">Bar</span>
          </div> -->

                <!-- Host Area -->
                <!-- <div class="host-area">
            <span class="area-label">Host</span>
          </div> -->

                <!-- Invisible area to expand scrollable space -->
                <div
                  style="
                    position: absolute;
                    width: 1000px;
                    height: 500px;
                    bottom: 0;
                    right: 0;
                    pointer-events: none;
                    opacity: 0;
                  "
                ></div>
              </div>
              </div>

              <!-- Bottom Actions -->
              <div class="bottom-actions">
               
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <notifications group="foo" />
    <!-- SUCCESS MODAL -->
    <div class="new_menu_success update" v-show="showSuccessMessage">
      <div class="mask" @click="detail_table = -1"></div>
      <transition name="fadeUp" class="new_menu_success_content_container">
        <div
          class="new_menu_success_content"
          style="animation-duration: 0.3s"
          v-if="showSuccessMessage && !showSuccessLoading"
        >
          <div class="close_modal">
            <img
              src="htttp://localhost:3333/new_images/close.png"
              @click="closeSuccess"
              alt=""
              srcset=""
            />
          </div>
          <div class="message_status">
            <div class="message_type">
              <span class="modal_circle"></span>
              <span>Réservation</span>
            </div>

            <div class="message_state">
              <span class="modal_circle"></span>
              <span class="modal_circle1"></span>
              <span class="modal_circle2"></span>
              <span>Enregistrée !</span>
            </div>
          </div>
          <div class="modal_infos">
            <span class="title"
              >Merci ! Votre réservation a bien été enregistrée. ✨</span
            ><br />
            <span class="title"
              >Vous recevrez une confirmation par e-mail/SMS sous peu.</span
            >

            <div class="modal_button" @click="closeSuccess">Terminer</div>
          </div>
        </div>
        <div
          class="new_menu_success_content"
          style="animation-duration: 0.3s"
          v-else
        >
          <div class="close_modal">
            <img
              src="htttp://localhost:3333/new_images/close.png"
              @click="closeSuccess"
              alt=""
              srcset=""
            />
          </div>
          <div class="message_status">
            <div class="message_type">
              <span class="modal_circle"></span>
              <span>Veuillez </span>
            </div>

            <div class="message_state">
              <span class="modal_circle"></span>
              <span class="modal_circle1"></span>
              <span class="modal_circle2"></span>
              <span>patienter !</span>
            </div>
          </div>
          <div class="modal_infos">
            <span class="title"
              >Votre réservation est en cours de validation</span
            >
          </div>
        </div>
      </transition>
    </div>
    <!-- ERROR MODAL -->
    <div class="new_menu_success error_modal" v-if="showError">
      <div class="mask" @click="detail_table = -1"></div>
      <div class="new_menu_success_content">
        <div class="close_modal">
          <img
            src="htttp://localhost:3333/new_images/close_dark.png"
            @click="showError = false"
            alt=""
            srcset=""
          />
        </div>
        <div class="message_status">
          <div class="message_type">
            <span class="modal_circle"></span>
            <span class="modal_circle1"></span>
            <span>Oups !</span>
          </div>
        </div>
        <div class="modal_infos">
          <span class="title"
            >Vous n’avez pas renseigné toutes les informations !</span
          >

          <div class="modal_button" @click="showError = false">Terminer</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import ReservationAddNewModal from "../containers/applications/ReservationNewModal";
// import ListReservation from "../views/app/pages/reservations/List";

import { getDirection } from "../utils";
import DragDrop from "vue-drag-n-drop";
import { VueDraggableDirective } from "vue-draggable";

import draggable from "vuedraggable";
import VueDragResize from "vue-drag-resize";

import { mapGetters, mapActions } from "vuex";
import Datepicker from "vuejs-datepicker";

import VueMaterialDateTimePicker from "vue-material-date-time-picker";
import "vue2-timepicker/dist/VueTimepicker.css";

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import "./plan/assets/tables.css";

import moment from "moment";
import Prepaiement from "./Prepaiement.vue";

import VueTimepicker from "vue2-timepicker";

import VFlowChart from "../../vue2-flow/src/components/FlowChart.vue";

// CSS
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-animate-transitions/dist/vue-animate-transitions.min.css";
require("vue2-animate/dist/vue2-animate.min.css");

export default {
  components: {
    VueMaterialDateTimePicker,
    draggable,
    DragDrop,
    Prepaiement,
    VFlowChart,
    VueDragResize,
    "v-select": vSelect,
    "vuejs-datepicker": Datepicker,
    // "reservation-add-new-modal": ReservationAddNewModal,
    // "list-res": ListReservation,
    VueTimepicker,
  },
  directives: {},
  data() {
    const month = new Date().getMonth();
    const year = new Date().getFullYear();
    let box = document.querySelector("body");

    var date = new Date();
    date.setDate(date.getDate() - 1);
    return {
      draggingTableId: null,
      activeTables: [],
      isPaused: true,
      panzoomInstance: null,
      showError: false,
      showSuccessMessage: false,
      showSuccessLoading: false,
      active_resa: 1,
      minutes_range: [],
      disabledDates: {
        to: date,
      },
      selectedSpace: 0,
      is_hour_changed: false,
      max_covers: 8,
      element_x: 0,
      element_y: 0,
      cnt_width: null,
      all_data: false,
      count_tables: 0,
      reservation: {
        adultes: 1,
        childs: 0,
      },
      date: new Date(),
      detail_table: -1,
      current: moment(),
      masks: {
        weekdays: "WWW",
      },
      active_tab: 0,
      showPopup: false,
      selected_table: null,
      direction: getDirection().direction,
      statuses: [
        {
          text: "ACTIVE",
          value: "ACTIVE",
        },
        {
          text: "COMPLETED",
          value: "COMPLETED",
        },
      ],
      labels: [
        {
          label: "EDUCATION",
          value: "EDUCATION",
          color: "secondary",
        },
        {
          label: "NEW FRAMEWORK",
          value: "NEW FRAMEWORK",
          color: "primary",
        },
        {
          label: "PERSONAL",
          value: "PERSONAL",
          color: "info",
        },
      ],

      rvc: {},
      settings: {
        maxScrollbarLength: 60,
      },
      options: {
        dropzoneSelector: ".planing_section",
        draggableSelector: ".draggable_item",
        handlerSelector: null,
        reactivityEnabled: true,
        multipleDropzonesItemsDraggingEnabled: true,
        showDropzoneAreas: true,
      },
      data: [],
      screenWidth: box.offsetWidth,
    };
  },
  computed: {
    tables_status_colors() {
      let colors = {};
      this.tables_status.map((item) => {
        if (item.status == "Occupied") {
          colors[item.DiningTableID] = "#FF0000"; // Red
        } else if (item.status == "Reserved") {
          colors[item.DiningTableID] = "#FFA500"; // Orange
        } else if (item.status == "Needs Cleaning") {
          colors[item.DiningTableID] = "#FFFF00"; // Yellow
        } else if (item.status == "Available") {
          colors[item.DiningTableID] = "#008000"; // Green
        } else {
          colors[item.DiningTableID] = "#808080"; // Grey for unknown status
        }
      });
      return colors;
    },
    nodes_v1() {
      let nodes_v1 = this.filtredData.map((itm, index) => {
        if (!itm.element) {
          return {
            id: itm._id,
            x: itm.left,
            y: itm.top,
            width: itm.width,
            height: itm.height,
            name: itm.Name.StringText._text,
            type: "input",
            shape: "rect",
            enableOptions: true,
            showOptions: true,
            draggable: true,
            shape: "circle",
            element: false,
            DiningTableID: itm.DiningTableID._text,
          };
        } else {
          return {
            id: index,
            x: itm.left,
            y: itm.top,
            width: itm.width,
            height: itm.height,
            name: "",
            image: itm.url,
            type: "input",
            shape: "rect",
            element: true,
            enableOptions: true,
            showOptions: true,
            draggable: true,
            shape: "circle",
          };
        }
      });
      return nodes_v1;
    },
    transformation() {
      if (!this.active_espaces || !this.active_espaces[this.selectedSpace]) {
        return { k: 1, x: 0, y: 0 };
      }
      return this.active_espaces[this.selectedSpace].transformation;
    },

    hour_resa() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get("heure");
    },
    is_payment() {
      return window.location.href.includes("/prepaiement/");
    },
    filtredData() {
      if (!this.active_espaces || !this.active_espaces[this.selectedSpace]) {
        return [];
      }
      return this.data.filter(
        (item) => (item.DiningTableID && item.DiningTableID._text &&
          (this.active_espaces[this.selectedSpace].tables.includes(item._id) ||
          (item.espace == this.active_espaces[this.selectedSpace]._id)))
      );
    },
    hour_range() {
      console.log("hour_range");
      let hours = [];
      for (let index = 0; index < this.serving_periods.length; index++) {
        let serving_period = this.serving_periods[index];
        // get day of the selected_date
        let day = moment(this.date).day();
        let period_days = serving_period.days.split("");
        if (period_days[day] == "1") {
          //  check start and end time
          this.active_hours.map((hour) => {
            if (hour.tables.length > 0) {
              if (
                hour.hour >= serving_period.start &&
                hour.hour < serving_period.end
              ) {
                let table = hour.tables.find(
                  (ht) => ht.Name.StringText._text * 1 == this.detail_table * 1
                );
                console.log({ hour: hour.hour.split(":")[0], table });
                if (table && !hours.includes(hour.hour.split(":")[0] * 1)) {
                  hours.push(hour.hour.split(":")[0] * 1);
                }
              }
            }
          });
        }
      }

      console.log(hours);
      return hours;
    },

    checks() {
      let checks = {};
      this.open_checks.map((item) => {
        checks[item.CheckTableObjectNum._text] = { ...item };
      });
      return checks;
    },
    restaurant_slug() {
      // let prams = window.location.href.split("?")[0].replace("https://","").split("/");
      let prams = window.location.href.split("?")[0].split("/");
      return prams[prams.length - 1];
    },

    used_tables() {
      let status = {};
      this.today_status.map((item) => {
        status[`${item.DiningTableID}`] = item;
      });
      return status;
    },
    tables_staus() {
      let status = {};
      this.tables_status.map((item) => {
        status[`${item.DiningTableID}`] = item;
      });
      return status;
    },
    reserved_tables() {
      return this.all_reservations
        .filter(
          (itm) => moment(itm.ReservationDate).format("HH:mm") == this.hour_resa
        )
        .map((itm) => itm.DiningTableID);
    },
    reservations_data() {
      let data = {};
      this.all_reservations.map((itm) => {
        data[`${itm.DiningTableID}`] = itm;
      });
      return data;
    },
    ...mapGetters([
      "espaces",
      "serving_periods",
      "tables",
      "poss",
      "reservation_tables",
      "all_reservations",
      "tables_status",
      "today_status",
      "open_checks",
      "active_hours",
      "startGetTables",
    ]),
    active_espaces() {
      return this.espaces.filter((itm) => itm.rvc == this.rvc.value);
    },

    centers() {
      if (this.poss[0]) {
        return this.poss[0].centers.map((item) => {
          return {
            label: item.name,
            value: item.rvc,
          };
        });
      }
      return [];
    },

    // Dynamic container dimensions based on table positions
    containerDimensions() {
      if (!this.filtredData || this.filtredData.length === 0) {
        return { width: '100%', height: '100%' };
      }

      const maxLeft = Math.max(...this.filtredData.map(table => table.left + (table.width || 100)));
      const maxTop = Math.max(...this.filtredData.map(table => table.top + (table.height || 100)));
      
      // Add padding for better scroll experience
      const paddingX = 100;
      const paddingY = 100;

      return {
        width: `${maxLeft + paddingX}px`,
        height: `${maxTop + paddingY}px`
      };
    },
  },
  watch: {
    "reservation.childs": function (newVal, oldVal) {
      if (newVal + this.reservation.adultes > this.max_covers) {
        this.$notify({
          group: "foo",
          type: "warn",
          title: "Couvertures maximales",
          text:
            "Le nombre maximum de couverts pour la table sélectionnée est " +
            this.max_covers,
        });
        if (oldVal + this.reservation.adultes > this.max_covers) {
          this.reservation.childs = 0;
        } else {
          this.reservation.childs = oldVal;
        }
      }
    },
    "reservation.adultes": function (newVal, oldVal) {
      if (newVal + this.reservation.childs > this.max_covers) {
        this.$notify({
          group: "foo",
          type: "warn",
          title: "Couvertures maximales",
          text:
            "Le nombre maximum de couverts pour la table sélectionnée est " +
            this.max_covers,
        });
        if (oldVal + this.reservation.childs > this.max_covers) {
          this.reservation.adultes = 0;
        } else {
          this.reservation.adultes = oldVal;
        }
      }
    },
    date(newval) {
      let date = moment(newval).format("YYYY-MM-DD");
      if (moment(date).isValid) {
        date = moment(date).format("DD-MM-YYYY");

        // this.checkTableHours({
        //   restaurant: this.restaurant_slug,
        //   date: date,
        //   rvc: this.rvc.value,
        // });

        this.$socket.emit("checkTableHours", {
          restaurant: this.restaurant_slug,
          date: date,
          rvc: this.rvc.value,
        });

        this.reservation.time = "";
      }
    },
    tables(newval) {
      let data = [...newval];

      let item = data[0];
      let count_tables = 0;
      if (item) {
        if (item.created_at == item.updated_at) {
          let per_ligne = 0;
          console.log("EGAL");
          let top = 40;
          let left = 40;
          for (let index = 0; index < data.length; index++) {
            const element = data[index];
            element.top = top;
            element.left = left;
            per_ligne++;
            if (per_ligne == 9) {
              top += 105;
              left = 40;
              per_ligne = 0;
            } else {
              left += 105;
            }

            data[index] == { ...element };
          }
        }
      }
      this.count_tables = data.filter((itm) => !item.element).length;
      this.data = data;
      // console.log({"hye": this.data})
    },
    rvc(newVal, oldVal) {
      let box = document.querySelector(".page_container_tables");
      let width = box.offsetWidth;
      let height = box.offsetHeight;
      //  containerWidth:width,containerHeight:height
      this.cnt_width = box.offsetWidth;

      if (newVal.value != oldVal.value) {
        let res_date = this.current.format("DD-MM-YYYY");

        this.getTablesStatus({
          restaurant: this.restaurant_slug,
          date: res_date,
          rvc: newVal.value,
        });
        this.getOpenChecks({
          restaurant: this.restaurant_slug,
          date: res_date,
          rvc: newVal.value,
        });

        this.getTables({
          restaurant: this.restaurant_slug,
          menu: { rvc: newVal.value },
          design: 1,
          containerWidth: width,
          containerHeight: height,
        }).then((res) => {
          this.all_data = true;
        });

        this.$socket.emit("checkTableHours", {
          restaurant: this.$route.params.restaurant,
          date: res_date,
          rvc: newVal.value,
        });

        let rvcobj = this.poss[0].centers.find(
          (item) => item.rvc == newVal.value
        );

        this.$socket.emit("getReservationsByDate", {
          restaurant: this.$route.params.restaurant,
          date: res_date,
          rvc: rvcobj.id,
        });

        // this.checkTableHours({
        //   restaurant: this.restaurant_slug,
        //   date: res_date,
        //   rvc: newVal.value,
        // });
      }

      // console.log(this.tables)
    },

    poss(newVal) {
      if (newVal[0]) {
        this.rvc = {
          label: newVal[0].centers[0].name,
          value: newVal[0].centers[0].rvc,
        };
      }
    },
  },
  methods: {
    clickNode(node, e) {
      console.log({ node });
      let item = this.filtredData.find((itm) => itm._id == node.id);
      this.setDetail(node.name * 1, e, item);
      this.selectedTableId = item._id;
    },
     clickTable(table) {
      console.log({ table });
      let item = { ...table };
      this.setDetail(item.Name.StringText._text * 1, item);
      this.selectedTableId = item._id;
    },
    closeSuccess() {
      this.showSuccessMessage = false;
      if (window.location.href.includes("&email=")) {
        window.location.href = window.location.href
          .split("?")[0]
          .replace("/reservations/", "/reservation/");
      }

      // this.GoBack();
    },
    changeHandler(event) {
      if (!this.reservation.time || this.reservation.time == "") {
        this.reservation.time = { HH: event.HH };
      }
      console.log(this.reservation);
      if (!this.reservation.time || this.reservation.time == "") {
        return [];
      }
      if (this.reservation.time.HH == "") {
        return [];
      }

      console.log("minutes_range");
      let minutes = [];

      for (let index = 0; index < this.serving_periods.length; index++) {
        let serving_period = this.serving_periods[index];
        // get day of the selected_date
        let day = moment(this.date).day();
        let period_days = serving_period.days.split("");
        if (period_days[day] == "1") {
          this.active_hours.map((hour) => {
            let hour_active = hour.hour.split(":");
            let select_hour = this.reservation.time.HH
              ? this.reservation.time.HH
              : this.reservation.time.split(":")[0];
            let disabled_hours =
              serving_period.disabled_hours[
                serving_period.disabled_hours.length - 1
              ].hours;
            console.log(select_hour);
            if (
              hour.hour >= serving_period.start &&
              hour.hour < serving_period.end
            ) {
              if (
                hour_active[0] == select_hour &&
                !disabled_hours.includes(hour.hour)
              ) {
                let table = hour.tables.find(
                  (ht) => ht.Name.StringText._text * 1 == this.detail_table * 1
                );

                if (
                  table &&
                  !minutes.includes(hour_active[1]) &&
                  hour.tables.length > 0
                ) {
                  minutes.push(hour_active[1] * 1);
                }
              }
            }
          });
        }
      }
      this.minutes_range = minutes;
    },
    onInit: function (panzoomInstance, id) {
      console.log("hiiiii");
      this.panzoomInstance = panzoomInstance;
      panzoomInstance.on("panend", function (e) {
        panzoomInstance.pause();
      });
      panzoomInstance.on("panstart", function (e) {
        panzoomInstance.resume();
      });
    },
    getChairs(count) {
      count -= 2;
      if (count == 0) {
        return [];
      }
      let chairs = [];
      for (var i = 0; i < count / 2; i++) {
        chairs.push(i);
      }
      return chairs;
    },
    reportWindowSize() {
      let box = document.querySelector(".resa_page");
      let width = box.offsetWidth;
      let height = box.offsetHeight;

      if (this.rvc && this.cnt_width != width) {
        this.cnt_width = width;

        this.getTables({
          restaurant: this.restaurant_slug,
          menu: { rvc: this.rvc.value },
          design: 1,
          containerWidth: width,
          containerHeight: height,
        }).then((res) => {
          this.all_data = true;
        });
      }
    },
    OpenTime() {
      //   if(document.querySelector(".input_date")){
      //     this.date = document.querySelector(".input_date").value
      //   }
    },

    setDetail(id, full_item) {
      this.detail_table = -1;
      setTimeout(() => {
        this.max_covers = full_item.MaximumCovers
          ? full_item.MaximumCovers * 1
          : 20;
        let box = document.querySelector(".page_container_tables");
        let width = box.offsetWidth;
        // if (width > 800) {
        //   let clicked_element_posiotion = event.target.getBoundingClientRect();
        //   this.element_x = clicked_element_posiotion.x;
        //   if (width - clicked_element_posiotion.x < 440) {
        //     this.element_x =
        //       clicked_element_posiotion.x -
        //       (440 - (width - clicked_element_posiotion.x));
        //   }
        //   this.element_y = clicked_element_posiotion.y;
        // } else {
        //   this.element_x = 0;

        //   this.element_y = 0;
        // }

        // alert(width-clicked_element_posiotion.x);
        // if(window.location.href.includes("&email=")){
        const urlParams = new URLSearchParams(window.location.search);
        this.reservation = {
          nom: urlParams.get("nom"),
          email: urlParams.get("email"),
          prenom: urlParams.get("prenom"),
          phone: urlParams.get("phone"),
          date: urlParams.get("date"),
          time: urlParams.get("date") + " " + urlParams.get("heure"),
          adultes: urlParams.get("adultes"),
          comment: urlParams.get("detail"),
          package: urlParams.get("package"),
          table: id,
        };
        //   //   let restaurant = this.restaurant_slug
        //   //   let params = `?heure=${urlParams.get('heure')}&email=${this.reservation.email}&phone=${this.reservation.phone}&nom=${this.reservation.nom}&prenom=${this.reservation.prenom}&date=${this.reservation.date}&adultes=${this.reservation.adultes}&detail=${this.reservation.comment}&table=${this.reservation.table}`;
        //   //   location.href = `htttp://localhost:3333/prepaiement/${restaurant}${params}`

        //   //   return

        //   // this.addItem()
        // }else{
        //   this.detail_table = id;
        // }
        this.detail_table = id;
        // this.addItem()
      }, 100);
    },
    gotToPrep() {
      const urlParams = new URLSearchParams(window.location.search);

      // const urlParams = new URLSearchParams(window.location.search);
      //     this.reservation = {
      //       nom:urlParams.get('nom'),
      //       email:urlParams.get('email'),
      //       prenom:urlParams.get('prenom'),
      //       phone:urlParams.get('phone'),
      //       date:urlParams.get('date'),
      //       time:urlParams.get('date')+" "+urlParams.get('heure'),
      //       adultes:urlParams.get('adultes'),
      //       comment:urlParams.get('detail'),
      //       table:id
      //     }

      this.reservation = {
        table:
          this.detail_table == -1 ? this.reservation.table : this.detail_table,
        nom: this.reservation.nom,
        email: this.reservation.email,
        prenom: this.reservation.prenom,
        phone: this.reservation.phone,
        date: urlParams.get("date"),
        heure: urlParams.get("heure"),
        duree: "",
        enfants: this.reservation.childs,
        adultes: this.reservation.adultes,
        detail: this.reservation.comment,
        package: urlParams.get("package"),
        rvc: this.rvc.value,
      };
      let prep_value = urlParams.get("valprep");
      let restaurant = this.restaurant_slug;
      let params = `?heure=${urlParams.get("heure")}&email=${
        this.reservation.email
      }&phone=${this.reservation.phone}&nom=${this.reservation.nom}&prenom=${
        this.reservation.prenom
      }&date=${this.reservation.date}&adultes=${
        this.reservation.adultes
      }&detail=${this.reservation.comment}&table=${
        this.reservation.table
      }&valprep=${prep_value}&package=${this.reservation.package}&rvc=${
        this.rvc.value
      }`;
      location.href = `htttp://localhost:3333/prepaiement/${restaurant}${params}`;
    },
    addItem() {
      let date = this.date;
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get("prepay")) {
        this.gotToPrep();
        return;
      }
      // alert(urlParams.get('package'))
      let newItem = {
        table:
          this.detail_table == -1 ? this.reservation.table : this.detail_table,
        nom: this.reservation.nom,
        email: this.reservation.email,
        prenom: this.reservation.prenom,
        phone: this.reservation.phone,
        date: new Date(moment(this.reservation.date).format("YYYY-MM-DD")),
        heure: `${moment(this.reservation.time).format("HH:mm")}`,
        duree: "",
        enfants: this.reservation.childs,
        adultes: this.reservation.adultes,
        detail: this.reservation.comment,
        package: urlParams.get("package"),
        rvc: this.rvc.value,
      };
      this.showSuccessMessage = true;
      this.showSuccessLoading = true;
      this.addReservation({
        restaurant: this.restaurant_slug,
        data: newItem,
      })
        .then((res) => {
          if (res.status == 202) {
            this.showSuccessLoading = false;
            this.showSuccessMessage = false;
            this.error = true;
            this.showError = true;
            this.detail_table = -1;

            // this.$notify({
            //     group: 'foo',
            //     type: 'error',
            //     title:"Erreur",
            //     text: 'Merci de remplir tout les champs.'
            // });

            // let errors = document.getElementsByClassName("error");
            // errors.forEach(err => {
            //   err.innerText = "";
            // });
            // res.data.forEach(element => {
            //   let el = element.field;
            //   this.$refs[el].textContent = element.message;
            // });
            // console.log(this.$refs);
          } else if (res.status == 200) {
            this.showSuccessLoading = false;
            this.showSuccessMessage = true;
            //   this.$notify({
            //     group: 'foo',
            //     type: 'success',
            //     title:"Success",
            //     text: 'Votre réservation à été ajouter avec succés.'
            // });

            this.reservation = {
              nom: "",
              prenom: "",
              time: "",
              duree: "",
              enfants: "",
              adultes: "",
              comment: "",
              package: "",
            };
            this.detail_table = -1;
            if (
              moment(this.date).format("DD-MM-YYYY") ==
              moment().format("DD-MM-YYYY")
            ) {
              // this.checkTableHours({
              //   restaurant: this.restaurant_slug,
              //   date: moment().format("DD-MM-YYYY"),
              //   rvc: this.rvc.value,
              // });

              this.$socket.emit("checkTableHours", {
                restaurant: this.restaurant_slug,
                date: moment().format("DD-MM-YYYY"),
                rvc: this.rvc.value,
              });
            } else {
              this.date = new Date();
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    disabled_hours() {
      let hours = [];
      this.active_hours.map((item) => {
        if (item.tables.length == 0) {
          hours.push(item.hour);
        }
      });
      return hours;
    },

    selectInput(e) {
      //   e.target.focus()
    },
    clickoutSide() {
      this.showPopup = false;
      this.detail_table = -1;
    },

    WalkIn() {
      this.$bvModal.show("modalrightRes");
    },
    getDateFormat(date, format) {
      return moment(date).format(format);
    },

    ...mapActions([
      "getEspaces",
      "getTablesStatus",
      "getAllReservations",
      "getTables",
      "editTables",
      "getMenusRvc",
      "commitGetReservationsByDateResult",
      "getPoss",
      "getCenters",
      "getCentersRes",
      "getOpenChecks",
      "checkTableHours",
      "addReservation",
      "getServingPeriods",
    ]),
    onEnd(obj) {
      console.log(obj);
    },

    createReservation(item) {
      this.$bvModal.show("modalrightRes");
    },
    listReservation(item) {
      this.selected_table = item;
      this.$bvModal.show("modalrightListRes");
    },
  },

  sockets: {
    connect: function () {
      console.log("socket connected");
    },
    getReservationsResult: function (data) {
      console.log(data);
      if (data) {
        this.commitGetMonthReservations(data);
      }
    },
    getReservationsByDateResult: function (data) {
      if (data) {
        if (data.data) {
          if (data.data.uniqueId == this.poss[0].restaurant) {
            console.log({ data });
            console.log("commitGetReservationsByDateResult");
            this.commitGetReservationsByDateResult(data);
          }
        }

        // alert("sss")
      }
    },

    CheckTableHoursResult: function (data) {
      console.log("CheckTableHoursResult");
      console.log(data);
      if (data) {
        this.commitCheckTableHoursResult(data);
        // alert("sss")
      }
    },
    refreshReservations: (data) => {
      let res_date1 = this.current.format("DD-MM-YYYY");

      let rvcobj = this.poss[0].centers.find(
        (item) => item.rvc == this.rvc.value
      );

      // alert("refresh")
      this.$socket.emit("getReservationsByDate", {
        restaurant: this.$route.params.restaurant,
        date: res_date1,
        rvc: rvcobj.id,
      });
    },
  },
  mounted() {
    window.onresize = this.reportWindowSize;
    window.addEventListener("deviceorientation", this.reportWindowSize, true);
    this.getPoss(this.restaurant_slug);
    this.getServingPeriods(this.restaurant_slug);

    this.getEspaces(this.restaurant_slug);
  },
};
</script>
<style lang="scss">
.page_container_tables_sub {
  overflow: hidden;
}
.select-list {
  .hours {
    flex-direction: column !important;
  }
}
.page_container_tables {
  display: flex;
  flex: 1;
  // width: 100%;
  // height: 1200px;
  // min-width: 1000px;
  // overflow: hidden;
  font-family: "Roboto";
  .config_section {
    flex: 2;
    background-color: #ebf1f4;
    background-color: #fff;
    // border-right: 1px solid #B3B3B3;
    padding-right: 0px;
    height: 1200px;
    overflow: hidden;
    .tables {
      height: 1200px;
      overflow: hidden;
      padding-bottom: 100px;
    }
    .tabs {
      display: flex;
      flex-direction: column;
      margin-bottom: 20px;
      // border-bottom:1px solid #B3B3B3;
      .tab {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 6px;
        background-color: #fff;
        color: #b3b3b3;
        font-size: 14px;
        // font-weight: 600;
        // letter-spacing: 1.5px;
        cursor: pointer;
        padding: 12px;
        .v-select.vs--single.vs--searchable {
          width: 100%;
        }
      }
      .save_button {
        background-color: #ffbc53;
        color: #fff;
      }
      .tab.active {
        color: #ffffff;
        border-bottom: 1px solid #ffffff;
        background: #4b4b4b;
      }
      .tab:first-of-type {
        // border-right: 1px solid #B3B3B3;
      }
    }

    .tables {
      .table {
        display: flex;
        padding: 0px 12px;
        align-items: center;
        // border-bottom: 0px dotted #b3b3b3;
        padding-bottom: 6px;
        padding-top: 6px;
        .table_cicle {
          display: flex;
          width: 40px;
          height: 40px;
          border-radius: 60%;
          -webkit-box-pack: center;
          -ms-flex-pack: center;
          justify-content: center;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          background-color: #9fe1de;
          color: #546e7a;
          font-size: 12px;
          font-weight: 600;
        }
        .table_infos {
          // width: 80%;
          // display: flex;
          padding-left: 8px;
          .client_name {
            font-weight: 400;
            font-size: 14px;
            // letter-spacing: 1.5px;
          }
          .events {
            font-size: 12px;
            color: #1baaae;
            font-weight: 600;
            span {
            }
          }
        }
        .order_infos {
          flex: 1;
          flex-direction: column;
          text-align: right;
          .date {
            font-weight: 600;
            font-size: 12px;
            color: #f1a129;
          }
          .order_number {
            color: #546e7a;
            font-weight: 400;
            font-size: 12px;
          }
        }
      }
    }
  }

  .planing_container {
    flex: 1;
    width: 100%;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    .planing_section {
      //  width: 00px;
      flex: 1;
      height: 1200px;
      overflow: hidden;
      background-color: #f6f3f1;
      background-color: #fff;
      //  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
      transition: 0.3s;
      position: relative;
      // border-radius: 21px;
      // background-image: url(/icons/background1.jpg);
      border: 1px solid #f4f4f4;
      background-repeat: repeat;
      background-size: contain;
    }
  }
}

.vdr.active:before {
  content: unset !important;
}
img.icon {
  width: 15px;
  cursor: pointer;
  margin: 6px;
}
.draggable_item {
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  // border-bottom: 1px solid gray;
  //   background-color: white;
  //   -webkit-box-shadow: -2px -1px 7px 1px rgba(148,148,148,0.63);
  // -moz-box-shadow: -2px -1px 7px 1px rgba(148,148,148,0.63);
  // box-shadow: -2px -1px 7px 1px rgba(148,148,148,0.63);
  //   margin-bottom: 3px;
}
.table_content {
  width: 60%;
  height: 70px;
  border: 1px solid white;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  color: #1baaae;
}
body {
  display: block;
  // width: 100%;
  // height: 100%;
  border-radius: unset !important;
  padding: 0px !important;
  background-color: white;
}
.h-100 {
  background-color: #f8f8f8;
}
.testtttt {
  display: flex;
  flex: 1;
  height: 100%;

  .tables_section {
    flex: 1;
    height: 100%;
    background-color: #1baaae;
  }
  .planing_section {
    flex: 1;
    position: relative;
    height: calc(100% - 100px);
    width: 100%;
    display: block;
    z-index: 9;
  }
  .planing_section::after {
    content: " ";
    // background-image: url(/back.jpeg);
    opacity: 0.5;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    z-index: -1;
    background-repeat: repeat;
    // background-size: cover;
  }
}
.send_button {
  border-radius: 5px;
  margin-top: 12px;
}
.switchers {
  display: flex;
  justify-content: center;
  padding: 20px 0px;
  padding-top: 30px;
  .center_switcher {
    margin: 0px 5px;
  }
  .switch {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    // background: white;

    border-radius: 20px;
    padding: 10px 0px;
    border-radius: 5px;
    cursor: pointer;
    span {
    }
  }
}
.container {
  background-color: white;
}
.form-control {
  border-radius: 5px;
}
.message_pending {
  min-height: 500px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  span {
    font-size: 16px;
    text-align: center;
  }
}
.box_container {
  width: 500px;
  height: 500px;
  margin: auto;
  background: white;
  position: relative;
}
.container {
  background: #fff;
}
.box-shaddow {
  // background: white;
}

.content_box.circle {
  // border-radius: 50%;
  // background-image: url(/icons/circle.png);
  .table_name {
    color: white;
    font-size: 10px !important;
    position: absolute;
    bottom: -5px;
    background: #546e7a;
    padding: 2px 4px;
    border-radius: 7px;
    min-width: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 22px;
  }
}
.table_name {
  color: white;
  font-size: 10px !important;
  position: absolute;
  bottom: -5px;
  background: #546e7a;
  padding: 2px 4px;
  border-radius: 7px;
  min-width: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 22px;
}
.content_box.circle.active {
  // background-image: url(/icons/circle_active.png);
}
.content_box {
  // background: #1baaae;
  display: flex;
  flex: 1;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  // background-image: url(/icons/square.png);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  border: 0px dashed rgba(128, 128, 128, 0.075);
  span {
    color: white;
    font-size: 16px;
  }
}

span.actions_tables {
  position: absolute;
  top: 0px;
  right: 0px;
  border-radius: 50%;
  background-color: #ffbc53;
  width: 22px;
  height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  div {
    display: block;
  }
  button {
    padding: 0px;
    width: 22px;
    height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      font-size: 12px;
      color: white;
    }
  }
}
.button_save,
.button_save:active,
.button_save:focus,
.button_save:visited {
  background-color: #278ee9 !important;
  border-color: #278ee9 !important;
  border-radius: unset !important;
}

.sub-hidden main,
.menu-sub-hidden main,
.menu-hidden main {
  margin-top: 125px;
  margin-right: 20px;
  margin-bottom: 30px;
  margin-left: 160px;
  padding: 20px;
  background-color: #fff;
  border-radius: 30px;
}

::-webkit-scrollbar {
  width: 0px;
}
::-webkit-scrollbar-track {
  display: none;
}
.vc-container {
  background: transparent;
  color: #fff;
}
.custom-calendar.vc-container {
  --day-border: 1px solid #b8c2cc;
  --day-border-highlight: 1px solid #b8c2cc;
  --day-width: 90px;
  --day-height: 90px;
  --weekday-bg: #f8fafc;
  --weekday-border: 1px solid #eaeaea;
  border-radius: 0;
  width: 100%;
  & .vc-header {
    background-color: transparent;
    padding: 10px 0;
  }
  & .vc-weeks {
    padding: 0;
  }
  & .vc-weekday {
    background-color: var(--weekday-bg);
    border-bottom: var(--weekday-border);
    border-top: var(--weekday-border);
    padding: 5px 0;
  }
  & .vc-day {
    padding: 0 5px 3px 5px;
    text-align: left;
    height: var(--day-height);
    min-width: var(--day-width);
    background-color: white;
    &.weekday-1,
    &.weekday-7 {
      background-color: #eff8ff;
    }
    &:not(.on-bottom) {
      border-bottom: var(--day-border);
      &.weekday-1 {
        border-bottom: var(--day-border-highlight);
      }
    }
    &:not(.on-right) {
      border-right: var(--day-border);
    }
  }
  & .vc-day-dots {
    margin-bottom: 5px;
  }
}

// .resa_infos_popup_form{
//     input{
//         height: 30px !important;
//         border-radius: 0px !important;
//         padding-left: 12px !important;
//     }
// }
.vmdtp_header[data-v-612d6560] {
  background: #f05d2e !important;
}

.vmdtp_main__item span.selected[data-v-f3a7035a] {
  background: #264740 !important;
}
.tables_button1 {
  padding: 12px;
  background: #f05d2e;
  color: #fff;
  text-align: center;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 6px 24px;
}
.tables_button1 .simple-icon-arrow-down {
  position: relative;
  left: 12px;
  font-size: 12px;
}

.status {
  margin-bottom: 12px;
}
.down_light {
  transform: rotate(-90deg);
  width: 7px;
  margin-left: 10px;
}
.new_menu_success {
  position: fixed;
  width: 100%;
  height: 100vh;
  z-index: 9999;
  top: 0px;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.mask {
  background: rgba(0, 0, 0, 0.65);
  position: absolute;
  left: 0px;
  top: 0px;
  height: 100%;
  width: 100%;
}
.new_menu_success_content {
  width: 35%;
  // height: 70%;
  height: fit-content;
  min-height: 400px;
  background: #264740;
  z-index: 9;
  border-radius: 5px;
  position: relative;
  padding: 32px;
}
.new_menu_success_content_container {
  width: 35%;

  .new_menu_success_content {
    width: 100%;
    // height: 70%;
    height: fit-content;
    min-height: 400px;
    background: #264740;
    z-index: 9;
    border-radius: 5px;
    position: relative;
    padding: 32px;
  }
}

.error_modal .new_menu_success_content {
  width: 35%;
  height: fit-content;
  background: #fff;
  z-index: 9;
  border-radius: 5px;
  position: relative;
  padding: 32px;
}
.close_modal {
  position: absolute;
  right: 24px;
  top: 24px;
  cursor: pointer;
}
.close_modal img {
  width: 48px;
}
.message_status {
}
.message_type {
  background: #fff;
  color: #264740;
  width: fit-content;
  font-size: 36px;
  position: relative;
  padding: 12px 24px;
  letter-spacing: 3px;
  font-weight: 600;
  border-radius: 5px;
}

.error_modal .message_type {
  background: #fff;
  color: #264740;
  width: fit-content;
  font-size: 36px;
  position: relative;
  padding: 12px 24px;
  letter-spacing: 3px;
  font-weight: 600;
  border-radius: 5px;
  border: 2px solid #264740;
  transform: rotate(8deg);
}

.error_modal .close_modal img {
}

.message_state {
  background: #fff;
  color: #264740;
  width: fit-content;
  font-size: 36px;
  transform: rotate(-12deg);
  position: relative;
  padding: 12px 24px;
  letter-spacing: 3px;
  font-weight: 600;
  border-radius: 5px;
  top: 22px;
}
.modal_circle {
  display: block;
  width: 10%;
  padding-top: 10%;
  background: #f05d2e;
  border-radius: 50%;
  position: absolute;
  left: 20%;
  bottom: 80%;
}

.error_modal .modal_circle {
  display: block;
  width: 18%;
  padding-top: 18%;
  background: #f05d2e;
  border-radius: 50%;
  position: absolute;
  left: 5%;
  top: 80%;
}

.error_modal .modal_circle1 {
  display: block;
  width: 18%;
  padding-top: 18%;
  background: #f05d2e;
  border-radius: 50%;
  position: absolute;
  left: 95%;
  bottom: 80%;
}

.message_type span {
}
.message_state {
}
.modal_circle1 {
  display: block;
  width: 10%;
  padding-top: 10%;
  background: #f05d2e;
  border-radius: 50%;
  position: absolute;
  left: 80%;
  bottom: 80%;
}
.modal_circle2 {
  display: block;
  width: 10%;
  padding-top: 10%;
  background: #f05d2e;
  border-radius: 50%;
  position: absolute;
  left: 40%;
  top: 80%;
}
.modal_infos {
  margin-top: 100px;
  color: #fff;
  text-align: center;
}
.modal_infos .title {
  font-weight: 600;
  font-size: 14px;
}
.modal_infos p {
  font-size: 12px;
  color: #fff !important;
  width: 65%;
  margin: auto;
  margin-top: 24px;
  margin-bottom: 24px;
  text-align: center;
}

.modal_infos .modal_button {
  width: 80%;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f05d2e;
  color: #fff;
  text-align: center;
  border-radius: 50px;
  padding: 9px;
  cursor: pointer;
  margin-top: 25px;
}

.error_modal .modal_infos .title {
  font-weight: 600;
  font-size: 14px;
  color: #264740;
}
.error_modal .modal_infos p {
  font-size: 12px;
  color: #264740 !important;
  width: 65%;
  margin: auto;
  margin-top: 24px;
  margin-bottom: 24px;
  text-align: center;
}
.btn.text-decoration-none {
  box-shadow: unset !important;
  border: unset !important;
}
.header_tables {
  display: none;
}
.header_tables_button {
  background: #f05d2e !important;
  color: #f6f3f1;
  width: 280px;
  text-align: center;
  padding: 12px;
  border-radius: 50px;
}
@media (max-width: 800px) {
  .new_menu_success_content {
    width: 100% !important;
    height: 100vh !important;
    padding-top: 50% !important;
  }
  .header_tables {
    width: 100%;
    padding: 12px;
    margin-bottom: 12px;
    display: flex !important;
    justify-content: center;
    align-items: center;
  }

  .tables_buttons_sections {
    justify-content: center !important;
  }
  .resa_page .status {
    margin-bottom: 12px;
  }
  .resa_page .table_status {
    margin-right: 12px !important;
  }
}
.inactive_table {
  opacity: 0.5 !important;
}

.spaces_section11 {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: auto !important;
  gap: 1.6%;
  margin-bottom: 0px;
  flex-wrap: wrap;
  width: 100%;
  flex: 1;
}
.space_section11 {
  border: 1px solid #fff;
  padding: 10px 3px;
  cursor: pointer;
  border-radius: 5px;
  background: #264740;
  color: #fff;
  width: max-content;
  width: 15%;
  min-width: max-content !important;
  text-align: center;
  margin-bottom: 8px;
  font-weight: 600;
  padding: 6px 12px;
  font-weight: normal;
  font-size: 1.2vw;
}
.space_section11.active {
  color: #fff;
  background: #f05d2e;
}

.chart__container {
  height: 80vh;
}

.chart__container .node .node_content {
  // pointer-events: none;
}
</style>

<style lang="scss" scoped>
.reservation-table-container {
  min-height: calc(100vh - 125px);
  background: #f8f9fa;
  background: transparent;
  color: #333;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

/* ZenChef Style Header */
.zenChef-header {
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  padding: 12px 20px;
  margin-bottom: 20px;
}

.header-main {
  display: flex;
  align-items: center;
  gap: 20px;
  max-width: 100%;
  
  @media (max-width: 1200px) {
    flex-wrap: wrap;
    gap: 15px;
  }
}

/* Search Container */
.search-container {
  position: relative;
  min-width: 200px;
  
  @media (max-width: 768px) {
    min-width: 150px;
  }
}

.search-container .search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #64748b;
  font-size: 14px;
  pointer-events: none;
}

.search-trigger {
  width: 100%;
  padding: 8px 12px 8px 36px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  background: white;
  transition: all 0.2s ease;
  cursor: pointer;
  color: #94a3b8;
  user-select: none;
  
  &:hover {
    border-color: #cbd5e1;
    background: #fafafa;
  }
}

/* Status Filters */
.status-filters {
  display: flex;
  gap: 8px;
  
  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 6px;
  }
}

.status-chip {
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;
  white-space: nowrap;
  
  &.late {
    background: rgba(239, 68, 68, 0.1);
    color: #dc2626;
    border-color: rgba(239, 68, 68, 0.2);
    
    &.active {
      background: #dc2626;
      color: white;
    }
  }
  
  &.occupied {
    background: rgba(16, 185, 129, 0.1);
    color: #059669;
    border-color: rgba(16, 185, 129, 0.2);
    
    &.active {
      background: #059669;
      color: white;
    }
  }
  
  &.available {
    background: rgba(34, 197, 94, 0.1);
    color: #16a34a;
    border-color: rgba(34, 197, 94, 0.2);
    
    &.active {
      background: #16a34a;
      color: white;
    }
  }
  
  &.reserved {
    background: rgba(245, 158, 11, 0.1);
    color: #d97706;
    border-color: rgba(245, 158, 11, 0.2);
    
    &.active {
      background: #d97706;
      color: white;
    }
  }
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
}

/* Header Controls */
.header-controls {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
  
  @media (max-width: 1200px) {
    margin-left: 0;
    flex-wrap: wrap;
  }
}

.dropdown-container {
  position: relative;
  min-width: 120px;
}

.header-dropdown {
  width: 100%;
  padding: 8px 32px 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: white;
  font-size: 14px;
  font-weight: 500;
  color: #1f2937;
  cursor: pointer;
  appearance: none;
}

.header-date-picker {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: white;
  font-size: 14px;
  font-weight: 500;
  color: #1f2937;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
  
  &:hover {
    border-color: #cbd5e0;
  }
}

.dropdown-arrow {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #6b7280;
  font-size: 12px;
  pointer-events: none;
}

/* View Toggle */
.view-toggle {
  display: flex;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  background: white;
}

.view-btn {
  padding: 8px 12px;
  border: none;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: #f1f5f9;
    color: #1f2937;
  }
  
  &.active {
    background: #ff6b35;
    color: white;
  }
  
  i {
    font-size: 14px;
  }
}

.user-status-bar {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}

.user-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;

  &.server {
    background: #1e7b3a;
    color: white;
  }

  &.manager {
    background: #8b5a9e;
    color: white;
  }

  &.admin {
    background: #4a8cc7;
    color: white;
  }
}

.user-initials {
  background: rgba(255, 255, 255, 0.2);
  padding: 2px 6px;
  border-radius: 10px;
  font-weight: bold;
  font-size: 10px;
}

.content-wrapper {
  display: flex;
  gap: 20px;
  min-height: 600px;

  @media (max-width: 1200px) {
    flex-direction: column;
    min-height: auto;
    gap: 15px;
  }

  @media (max-width: 768px) {
    padding: 0 10px;
    gap: 10px;
  }
}

.reservations1-panel {
  width: 320px;
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  height: fit-content;

  @media (max-width: 1200px) {
    width: 100%;
    max-height: 400px;
  }

  @media (max-width: 768px) {
    max-height: 300px;
  }
}

.filter-tabs {
  display: flex;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  border-radius: 8px 8px 0 0;
}

.tab-item {
  flex: 1;
  padding: 12px 16px;
  text-align: center;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  color: #6c757d;

  &.active {
    border-bottom-color: #f05d2e;
    background: white;
    color: #f05d2e;
  }

  &:hover:not(.active) {
    background: #e9ecef;
  }

  .tab-title {
    display: block;
    font-size: 14px;
    font-weight: 500;
  }

  .tab-count {
    display: block;
    font-size: 12px;
    opacity: 0.7;
  }
}


.date-filters {
  display: flex;
  gap: 8px;
  padding: 15px;
  border-bottom: 1px solid #e9ecef;
  background: white;
}

.filter-btn {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  color: #495057;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: all 0.2s ease;

  &.active {
    background: #f05d2e;
    color: white;
    border-color: #f05d2e;
  }

  &:hover:not(.active) {
    background: #e9ecef;
    border-color: #adb5bd;
  }
}

.reservations1-list {
  flex: 1;
  overflow-y: auto;
  padding: 15px;
  max-height: 647px;
  // max-height: 90vh;
}

.reservation-item {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 12px;
  border-left: 3px solid #f05d2e;
  transition: all 0.2s ease;
  position: relative;
  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transform: translateY(-1px);
  }
}
.reservation-count {
  position: absolute;
  top: 8px;
  right: 8px;
  background: #f05d2e;
  color: white;
  padding: 2px 6px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  // box-shadow: 0 2px 4px rgba(0,0,0
}

.reservation-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 4px;
}

.guest-name {
  font-weight: 600;
  font-size: 16px;
  color: #2c3e50;
  margin-right: 12px;
}

.guest-icon {
  width: 16px;
  height: 16px;
  border-radius: 50%;

  &.google {
    background: #4285f4;
  }

  &.online {
    background: #00ff00;
  }
}

.reservation-details {
  display: flex;
  gap: 8px;
  font-size: 12px;
  color: #6c757d;
  margin-bottom: 4px;
  justify-content: space-between;
}
.reservation-details {
  .table-info {
    background: #264740;
    color: #fff;
    padding: 2px 5px;
    border-radius: 10px;
  }
}
.reservation-details-time {
  position: relative;
  top: 20px;
  font-weight: bold;
  text-transform: uppercase;
}

.reservation-source {
  font-size: 11px;
  color: #6c757d;
  margin-bottom: 8px;
}

.status-badge {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;

  &.arrived {
    background: #1e7b3a;
    color: white;
  }

  &.seated {
    background: #1e7b3a;
    color: white;
  }

  &.confirmed {
    background: #8b5a9e;
    background: #f05d2e;
    color: white;
  }

  &.reserved {
    background: #8b5a9e;
    background: #f05d2e;
    color: white;
  }

  &.noshow {
    background: #666;
    color: white;
  }

  &.over {
    background: #000;
    color: white;
  }
}

.add-reservation-btn {
  width: 100%;
  background: #f05d2e;
  border: none;
  color: white;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s ease;

  &:hover {
    background: #0056b3;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
  }
}

.tables-new-container{
  flex: 1;
  width: 100%;
  overflow: scroll;
}
.table-layout-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  height: 100%;
  @media (max-width: 1200px) {
    // min-height: 500px;
  }

  @media (max-width: 768px) {
    // min-height: 400px;
  }
}

.room-tabs {
  display: flex;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.room-tab {
  padding: 12px 24px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  color: #6c757d;
  font-weight: 500;
  transition: all 0.2s ease;

  &.active {
    background: white;
    border-bottom-color: #f05d2e;
    color: #f05d2e;
  }

  &:hover:not(.active) {
    background: #e9ecef;
  }
}

.table-layout-area {
  flex: 1;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  position: relative;
  overflow: auto;
  min-height: 600px;
  max-height: calc(100vh - 00px);
  padding: 24px;
  width: 100%;
  box-sizing: border-box;

  /* Subtle grid pattern for better spatial awareness */
  background-image: 
    radial-gradient(circle at 1px 1px, rgba(99, 102, 241, 0.08) 1px, transparent 0);
  background-size: 20px 20px;

  /* Enable smooth scrolling */
  scroll-behavior: smooth;

  /* Enable touch scrolling on mobile */
  -webkit-overflow-scrolling: touch;

  /* Modern custom scrollbars */
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(241, 245, 249, 0.8);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, #94a3b8 0%, #64748b 100%);
    border-radius: 3px;
    transition: all 0.2s ease;

    &:hover {
      background: linear-gradient(180deg, #64748b 0%, #475569 100%);
    }
  }

  @media (max-width: 1200px) {
    // min-height: 400px;
    max-height: 100vh;
    padding: 20px;
  }

  @media (max-width: 768px) {
    // min-height: 350px;
    max-height: 70vh;
    padding: 16px;
    background-size: 16px 16px;
    overflow-x: scroll;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    min-width: 100%;
  }

  @media (max-width: 480px) {
    padding: 12px;
    // min-height: 300px;
    background-size: 12px 12px;
    max-height: 60vh;
    overflow-x: scroll;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }
}

.table-element {
  position: absolute;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e1e8ed;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  background: #ffffff;
  backdrop-filter: blur(8px);
  
  /* Touch targets for mobile */
  @media (max-width: 768px) {
    min-width: 44px;
    min-height: 44px;
  }

  &.rectangle {
    border-radius: 8px;
  }

  &.square {
    border-radius: 6px;
  }

  &.diamond {
    clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);
    border-radius: 0;
  }

  &.circle {
    border-radius: 50%;
  }
  
  // ZenChef-inspired status colors with subtle gradients
  &.occupied,
  &.seated {
    border-color: #10b981;
    background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
    box-shadow: 0 4px 6px rgba(16, 185, 129, 0.1), 0 2px 4px rgba(16, 185, 129, 0.06);
  }

  &.reserved,
  &.confirmed {
    border-color: #f59e0b;
    background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
    box-shadow: 0 4px 6px rgba(245, 158, 11, 0.1), 0 2px 4px rgba(245, 158, 11, 0.06);
  }

  &.unavailable,
  &.canceled {
    border-color: #ef4444;
    background: linear-gradient(135deg, #fef2f2 0%, #fecaca 100%);
    box-shadow: 0 4px 6px rgba(239, 68, 68, 0.1), 0 2px 4px rgba(239, 68, 68, 0.06);
  }

  &.special {
    background: linear-gradient(135deg, #fdf4ff 0%, #f3e8ff 100%);
    border-color: #a855f7;
    color: #7c3aed;
    box-shadow: 0 4px 6px rgba(168, 85, 247, 0.1), 0 2px 4px rgba(168, 85, 247, 0.06);
  }

  &:hover {
    transform: translateY(-2px) scale(1.02);
    z-index: 10;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12), 0 4px 10px rgba(0, 0, 0, 0.08);
    border-color: #6366f1;
  }

  &.edit-mode {
    cursor: move;
    border: 2px dashed #6366f1;
    background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);

    &:hover {
      border-color: #4f46e5;
      background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
    }
  }

  &.dragging {
    opacity: 0.9;
    transform: translateY(-4px) scale(1.08) !important;
    z-index: 1000 !important;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15), 0 8px 16px rgba(0, 0, 0, 0.1);
    border-color: #6366f1;
  }
}

.table-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  z-index: 2;
  text-align: center;
  padding: 3px;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.table-number {
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
  letter-spacing: 0.5px;
  line-height: 1.2;
  margin-bottom: 2px;
}

.table-capacity {
  font-size: 10px;
  font-weight: 500;
  color: #6b7280;
  opacity: 0.9;
  margin-top: 1px;
}

.reservation-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  overflow: hidden;
  max-height: calc(100% - 16px); // Leave space for table number
}

.guest-name {
  font-size: 9px;
  font-weight: 600;
  color: #374151;
  line-height: 1.1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  margin-bottom: 2px;
  text-transform: capitalize;
  display: flex;
  align-items: center;
  justify-content: center;
}

.star_vip_table{

    position: absolute;
    top: 0;
    right: 0px;

}
.vip-star {
  color: #fbbf24;
  font-size: 8px;
  margin-right: 2px;
  flex-shrink: 0;
}

.reservation-time {
  font-size: 8px;
  font-weight: 700;
  color: #059669;
  background: rgba(5, 150, 105, 0.1);
  padding: 1px 4px;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  border: 1px solid rgba(5, 150, 105, 0.2);
}

// Responsive adjustments for different table sizes
.table-element {
  // Small tables
  &[style*="width: 40px"], &[style*="width: 44px"] {
    .guest-name {
      font-size: 8px;
      max-width: 36px;
      
      .vip-star {
        font-size: 6px;
        margin-right: 1px;
      }
    }
    .reservation-time {
      font-size: 7px;
      padding: 1px 2px;
    }
  }

  // Medium tables  
  &[style*="width: 60px"] {
    .guest-name {
      font-size: 9px;
      max-width: 54px;
      
      .vip-star {
        font-size: 7px;
      }
    }
    .reservation-time {
      font-size: 8px;
    }
  }

  // Large tables
  &[style*="width: 80px"] {
    .guest-name {
      font-size: 10px;
      max-width: 74px;
      
      .vip-star {
        font-size: 8px;
      }
    }
    .reservation-time {
      font-size: 9px;
      padding: 2px 5px;
    }
  }
}

.table-status-indicator {
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 3;
}

.status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.05);
  }
}

.bar-area,
.host-area {
  position: absolute;
  background: rgba(255, 255, 255, 0.9);
  border: 2px dashed #adb5bd;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6c757d;
  font-weight: bold;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.bar-area {
  top: 50px;
  right: 50px;
  width: 80px;
  height: 120px;
}

.host-area {
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 60px;
}

.bottom-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 15px;
  background: white;
  border-top: 1px solid #e9ecef;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
    padding: 10px;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 6px;
    padding: 8px;
  }
}

.action-btn {
  background: #6c757d;
  border: none;
  color: white;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;

  @media (max-width: 768px) {
    padding: 10px 14px;
    font-size: 13px;
    min-height: 44px; // Touch target size
  }

  @media (max-width: 480px) {
    width: 100%;
    justify-content: center;
    padding: 12px;
  }

  &:hover {
    background: #5a6268;
    transform: translateY(-1px);
  }

  &.notification-btn {
    position: relative;
  }
}

.notification-count {
  background: #ff4444;
  color: white;
  border-radius: 50%;
  padding: 2px 6px;
  font-size: 10px;
  position: absolute;
  top: -4px;
  right: -4px;
}

.select-tables-btn {
  background: #f05d2e;

  &:hover {
    background: #0056b3;
  }
}

.save-btn {
  background: #28a745;

  &:hover {
    background: #1e7e34;
  }
}

.action-btn.active {
  background: #fd7e14;

  &:hover {
    background: #e66a00;
  }
}

.bottom-nav {
  background: #1a1a1a;
  border-top: 1px solid #404040;
  display: flex;
  height: 60px;
}

.nav-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
  color: #888;

  &.active {
    color: #ff6b35;
  }

  &:hover {
    background: #2a2a2a;
  }
}

// Simple icons styling
i[class*="simple-icon"] {
  font-size: inherit;
  line-height: inherit;
}

// Responsive Design
// Table Controls
.table-controls {
  position: absolute;
  top: -36px;
  right: -12px;
  display: flex;
  gap: 6px;
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform: translateY(8px);
}

.table-element.edit-mode:hover .table-controls {
  opacity: 1;
  transform: translateY(0);
}

.control-btn {
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 6px;
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
  color: white;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(99, 102, 241, 0.2);
  transition: all 0.2s ease;

  &:hover {
    background: linear-gradient(135deg, #4f46e5 0%, #4338ca 100%);
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(99, 102, 241, 0.3);
  }

  &.delete-btn {
    background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
    box-shadow: 0 2px 4px rgba(239, 68, 68, 0.2);

    &:hover {
      background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
      box-shadow: 0 4px 8px rgba(239, 68, 68, 0.3);
    }
  }

  &.rotate-btn, &.resize-btn {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    box-shadow: 0 2px 4px rgba(16, 185, 129, 0.2);

    &:hover {
      background: linear-gradient(135deg, #059669 0%, #047857 100%);
      box-shadow: 0 4px 8px rgba(16, 185, 129, 0.3);
    }
  }
}

// Modal Styles
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.reservation-modal,
.add-table-modal {
  background: white;
  border-radius: 12px;
  padding: 0;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
}

.modal-header {
  background: #f8f9fa;
  padding: 16px 20px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h3 {
    margin: 0;
    color: #2c3e50;
    font-size: 18px;
    font-weight: 600;
  }
}

.close-btn {
  background: none;
  border: none;
  color: #6c757d;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  &:hover {
    background: #e9ecef;
    color: #495057;
  }
}

.reservation-form,
.table-form {
  padding: 20px;
  max-height: 70vh;
  overflow-y: auto;
}

.form-row {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;

  .form-group {
    flex: 1;
  }
}

.form-group {
  margin-bottom: 16px;

  &.full-width {
    width: 100%;
  }

  label {
    display: block;
    margin-bottom: 6px;
    color: #ccc;
    font-size: 14px;
    font-weight: 500;
  }

  input,
  select,
  textarea {
    width: 100%;
    background: white;
    border: 1px solid #ced4da;
    color: #495057;
    padding: 10px 12px;
    border-radius: 6px;
    font-size: 14px;

    &:focus {
      outline: none;
      border-color: #f05d2e;
      box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);
    }

    &::placeholder {
      color: #6c757d;
    }
  }

  textarea {
    resize: vertical;
    min-height: 80px;
  }
}

.form-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e9ecef;
}

.btn-cancel,
.btn-submit {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-cancel {
  background: #6c757d;
  color: white;

  &:hover {
    background: #5a6268;
  }
}

.btn-submit {
  background: #f05d2e;
  color: white;

  &:hover {
    background: #0056b3;
  }
}

// Context Menu
.context-menu {
  position: fixed;
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 4px 0;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
  z-index: 3000;
  min-width: 160px;
}

.context-item {
  padding: 8px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #495057;

  &:hover {
    background: #f8f9fa;
  }

  &.danger {
    color: #dc3545;

    &:hover {
      background: #dc3545;
      color: white;
    }
  }
}

@media (max-width: 768px) {
  .content-wrapper {
    flex-direction: column;
  }

  .left-sidebar {
    width: 100%;
    height: 300px;
  }

  .user-status-bar {
    flex-wrap: wrap;
  }

  .filter-tabs {
    font-size: 12px;
  }

  .reservation-modal,
  .add-table-modal {
    width: 95%;
    margin: 10px;
  }

  .form-row {
    flex-direction: column;
    gap: 0;
  }

  .table-controls {
    opacity: 1; // Always show on mobile
  }
}

.shapes-tables {
  display: flex;
  justify-content: flex-start;
  gap: 12px;
  margin-right: 12px;
}

.shape-tables {
  padding: 5px;
  cursor: pointer;
}

.tables-actions {
  flex: 1;
  display: flex;
  justify-content: flex-start;
  gap: 12px;
}
.mask-table{
  background: #fff;
  width: 100%;
  height: 100%;
  position: absolute;
}

// Check Details Modal Styles
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.check-details-modal {
  background: white;
  border-radius: 12px;
  max-width: 600px;
  width: 90%;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  
  .modal-header {
    background: #f8fafc;
    padding: 20px;
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    h3 {
      margin: 0;
      font-size: 20px;
      font-weight: 600;
      color: #1f2937;
    }
    
    .close-btn {
      background: none;
      border: none;
      font-size: 20px;
      color: #6b7280;
      cursor: pointer;
      padding: 8px;
      border-radius: 8px;
      transition: all 0.2s;
      
      &:hover {
        background: #e5e7eb;
        color: #374151;
      }
    }
  }
  
  .modal-body {
    padding: 20px;
    overflow-y: auto;
    max-height: calc(80vh - 80px);
  }
  
  .check-info-section,
  .menu-items-section,
  .totals-section {
    margin-bottom: 24px;
    
    h4 {
      margin: 0 0 12px 0;
      font-size: 16px;
      font-weight: 600;
      color: #374151;
    }
  }
  
  .info-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }
  
  .info-item {
    display: flex;
    justify-content: space-between;
    padding: 8px 0;
    
    .info-label {
      color: #6b7280;
      font-size: 14px;
    }
    
    .info-value {
      color: #1f2937;
      font-weight: 500;
      font-size: 14px;
      
      &.status-badge {
        background: #dcfce7;
        color: #166534;
        padding: 2px 8px;
        border-radius: 12px;
        font-size: 12px;
        text-transform: uppercase;
      }
    }
  }
  
  .items-list {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    overflow: hidden;
  }
  
  .menu-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #f3f4f6;
    
    &:last-child {
      border-bottom: none;
    }
    
    .item-info {
      display: flex;
      align-items: center;
      gap: 12px;
      
      .item-name {
        font-weight: 500;
        color: #374151;
      }
      
      .item-quantity {
        color: #6b7280;
        font-size: 14px;
      }
    }
    
    .item-price {
      font-weight: 600;
      color: #059669;
    }
  }
  
  .totals-grid {
    border-top: 1px solid #e5e7eb;
    padding-top: 12px;
  }
  
  .total-item {
    display: flex;
    justify-content: space-between;
    padding: 8px 0;
    
    .total-label {
      color: #6b7280;
      font-size: 14px;
    }
    
    .total-value {
      font-weight: 500;
      color: #374151;
    }
    
    &.total-due {
      border-top: 2px solid #e5e7eb;
      margin-top: 8px;
      padding-top: 12px;
      
      .total-label {
        font-weight: 600;
        color: #1f2937;
        font-size: 16px;
      }
      
      .total-value {
        font-weight: 700;
        color: #059669;
        font-size: 18px;
      }
    }
  }
}
</style>